(() => {
  const script = document.querySelector('script[data-wishlist-script]');
  if (!script) return;

  const storageKey = 'azha:wishlist:v1';
  const limit = 128;
  const rootUrl = script.dataset.rootUrl || '/';
  const globalStatus = document.querySelector('[data-wishlist-status]');
  const page = document.querySelector('[data-wishlist-page]');
  let renderVersion = 0;

  const showError = (message) => {
    if (globalStatus) {
      globalStatus.textContent = message;
      globalStatus.hidden = false;
    }
    const pageStatus = page?.querySelector('[data-wishlist-page-status]');
    if (pageStatus) pageStatus.textContent = message;
  };

  const clearError = () => {
    if (globalStatus) {
      globalStatus.textContent = '';
      globalStatus.hidden = true;
    }
    const pageStatus = page?.querySelector('[data-wishlist-page-status]');
    if (pageStatus) pageStatus.textContent = '';
  };

  const validItem = (item) => item && /^\d+$/.test(String(item.id)) && /^[a-z0-9][a-z0-9-]*$/.test(String(item.handle));

  const normalize = (items) => {
    if (!Array.isArray(items)) return [];
    const ids = new Set();
    return items.filter((item) => {
      const id = String(item?.id || '');
      if (!validItem(item) || ids.has(id)) return false;
      ids.add(id);
      return true;
    }).slice(0, limit).map((item) => ({ id: String(item.id), handle: String(item.handle) }));
  };

  const read = () => {
    try {
      return normalize(JSON.parse(localStorage.getItem(storageKey) || '[]'));
    } catch {
      showError(script.dataset.storageError);
      return [];
    }
  };

  const save = (items) => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(items));
      clearError();
      return true;
    } catch {
      showError(script.dataset.storageError);
      return false;
    }
  };

  const syncButtons = (items = read()) => {
    const ids = new Set(items.map((item) => item.id));
    document.querySelectorAll('[data-wishlist-button]').forEach((button) => {
      const saved = ids.has(button.dataset.productId);
      button.dataset.saved = String(saved);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', saved ? button.dataset.removeLabel : button.dataset.addLabel);
    });
  };

  const buildMissingCard = (item, loadFailed) => {
    const card = document.createElement('article');
    card.className = 'flex min-h-48 flex-col justify-between border border-line bg-paper p-5';
    const message = document.createElement('p');
    message.className = 'text-sm text-muted';
    message.textContent = loadFailed ? script.dataset.loadError : script.dataset.removed;
    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'mt-5 min-h-11 self-start text-sm text-ink underline underline-offset-4 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink';
    remove.dataset.wishlistRemove = item.id;
    remove.textContent = script.dataset.remove;
    card.append(message, remove);
    return card;
  };

  const fetchCard = async (item) => {
    try {
      const response = await fetch(`${rootUrl}products/${encodeURIComponent(item.handle)}?section_id=wishlist-product-card`, { credentials: 'same-origin' });
      if (response.status === 404) return buildMissingCard(item, false);
      if (!response.ok) return buildMissingCard(item, true);
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const product = documentFragment.querySelector('[data-wishlist-product-id]');
      if (!product || product.dataset.wishlistProductId !== item.id) return buildMissingCard(item, false);
      return product;
    } catch {
      return buildMissingCard(item, true);
    }
  };

  const renderPage = async () => {
    syncButtons();
    if (!page) return;
    const version = ++renderVersion;
    const items = read();
    const empty = page.querySelector('[data-wishlist-empty]');
    const grid = page.querySelector('[data-wishlist-grid]');
    empty.hidden = items.length > 0;
    grid.hidden = items.length === 0;
    if (!items.length) {
      grid.replaceChildren();
      return;
    }
    const cards = await Promise.all(items.map(fetchCard));
    if (version !== renderVersion) return;
    grid.replaceChildren(...cards);
    syncButtons(items);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-button]');
    const remove = event.target.closest('[data-wishlist-remove]');
    if (!button && !remove) return;

    const items = read();
    const id = button ? button.dataset.productId : remove.dataset.wishlistRemove;
    const index = items.findIndex((item) => item.id === id);
    if (index >= 0) {
      items.splice(index, 1);
    } else if (button) {
      if (items.length >= limit) {
        showError(script.dataset.limitError);
        return;
      }
      items.push({ id, handle: button.dataset.productHandle });
    }
    if (save(normalize(items))) renderPage();
  });

  window.addEventListener('storage', (event) => {
    if (event.key === storageKey) renderPage();
  });

  const observer = new MutationObserver((records) => {
    if (records.some((record) => [...record.addedNodes].some((node) => node.nodeType === 1 && (node.matches?.('[data-wishlist-button]') || node.querySelector?.('[data-wishlist-button]'))))) {
      syncButtons();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  renderPage();
})();
